/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/seasonal-images.js":
/*!*******************************************!*\
  !*** ./src/js/modules/seasonal-images.js ***!
  \*******************************************/
/***/ (() => {

window.theme = window.theme || {};

theme.SeasonalImages = function () {
  var settings = {
    adaptiveHeight: true,
    pageDots: true,
    wrapAround: false,
    prevNextButtons: false,
    on: {
      ready: function ready() {
        this.pageDots.holder.style.setProperty('--slides-count', this.cells.length);
        setDotsTitles(this);
      }
    }
  };
  var selectors = {
    slides: '[data-slides]'
  };

  function setDotsTitles(flickity) {
    var dots = flickity.pageDots.dots;
    var slides = flickity.cells.map(function (cell) {
      return cell.element;
    });
    dots.forEach(function (dot, index) {
      var title = slides[index].getAttribute('data-title');
      dot.setAttribute('aria-label', title);
    });
  }

  function SeasonalImages(container) {
    this.container = container;
    this.init();
  }

  SeasonalImages.prototype = Object.assign({}, SeasonalImages.prototype, {
    init: function init() {
      this._initSlideshow();
    },
    _initSlideshow: function _initSlideshow() {
      var _this = this;

      this.flickity = new Flickity(this.container.querySelector(selectors.slides), settings);
      window.addEventListener('resize', function () {
        _this.flickity.resize();
      });
    },
    onUnload: function onUnload() {
      this.flickity.destroy();
    }
  });
  return SeasonalImages;
}();

document.addEventListener('DOMContentLoaded', function () {
  if (!theme.sections) {
    document.addEventListener('page:loaded', function () {
      var _theme;

      (_theme = theme) === null || _theme === void 0 ? void 0 : _theme.sections.register('seasonal-images', theme.SeasonalImages);
    });
  }

  theme.sections.register('seasonal-images', theme.SeasonalImages);
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_seasonal_images__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/seasonal-images */ "./src/js/modules/seasonal-images.js");
/* harmony import */ var _modules_seasonal_images__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_seasonal_images__WEBPACK_IMPORTED_MODULE_0__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;